<div id="masonryItem">
  <div class="imgWrapper">
    <a class="w-full" [href]="data.HotelUrl" target="_blank">
      <img [src]="data.PictureUrl"   (error)="data.PictureUrl = cdnUrl + '/images/no-image.jpg'"  class="img-fluid">
    </a>
  </div>
  <!-- --- -->
  <div class="px-3">
    <a [href]="data.HotelUrl" target="_blank">
      <h3 class="fw-bold text-base mt-4">
        <div class="hidden md:block" style="font-weight: bold !important;">
           {{(data.HotelType + ' ' + data.HME_P_Name + ' ' + data.CityTitle) }}
           {{(data.HotelType + ' ' + data.HME_P_Name + ' ' + data.CityTitle).length > 28 ? '...' : ''}}
        </div>
        <div class="block md:hidden" style="font-weight: bold !important;">
          {{(data.HotelType + ' ' + data.HME_P_Name + ' ' + data.CityTitle)}}
        </div>

      </h3>
    </a>
    <!-- --- -->
    <div class="d-block my-3">
    <div
      class="score__segment position-relative overflow-hidden flex flex-row flex-nowrap justify-start items-center lh-1 user-select-none mt-2">
      <div
        class="wrapper score__number--border text-center flex items-center justify-center p-2 ml-2 bg-blue-500">
        <p class="score__number text-base px-1 text-white">{{data.HotelRank?data.HotelRank:data.AvgRate}}</p>
      </div>
    
      <div class="wrapper text-start">
        <p class="score__text fw-bold pb-1 text-black text-sm" style="font-weight: bold !important;">{{data.AvgRateTitle}}</p>
        <p class="score__description text-xs">
          {{data.TotalReview}}
          نظر واقعی
        </p>
      </div>
    </div>

    </div>
    <!-- --- -->
    <div class="content border-bottom">
      <!-- --- -->
      <h4 class="text-sm fw-medium"style="font-weight: 500 !important;" >"{{data.Title}}"</h4>
      <!-- --- -->
      <p class="text-sm mb-2">
        {{ isTruncate ? (data.Description ) : data.Description }}
        {{isTruncate ? (data.Description.length > 50 ? '...' : '') : ''}}
      </p>
    </div>
    <!-- --- -->
    <div class="flex py-3 justify-between text-gray-600">
      <h5 class="flex-grow-1 text-xs mb-0" *ngIf="data.P_Name">
        {{data.P_Name}}
      </h5>
      <h5 class="flex-grow-1 text-xs mb-0" *ngIf="data.FirstName">{{data.FirstName}}</h5>
      <h5 class="text-xs mb-0">
        {{data.AddDate | isoToJalali}}
        <span *ngIf="data.AddDate" class="text-warning3 mx-1" style="color: #ffb500"> | </span>
        {{data.Duration?data.Duration:2}} شب اقامت</h5>
    </div>
  </div>

</div>
